import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import parkingConfig from './modules/parkingConfig'
import incomeStat from './modules/incomeStat'

// default router permission control
// 默认路由模式为静态路由 (router.config.js)
import permission from './modules/static-router'

// dynamic router permission control (Experimental)

import getters from './getters'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    parkingConfig,
    incomeStat
  },
  state: {
    contentIsNeedRefresh: false
  },
  mutations: {},
  actions: {},
  getters
})
